import React from "react";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
class RegisterWizard extends React.Component {
  back = (event) => {
    event.preventDefault();
    event.stopPropagation();
	if(this.props.webPage === "/registerPassword"){
		this.props.history.replace("/confirmPhone");
	}else if(this.props.webPage === "/confirmPhone"){
		this.props.history.replace("/registerPhone");
	}else if(this.props.webPage === "/registerPhone"){
		this.props.history.replace("/confirmEmail");
	}else if(this.props.webPage === "/confirmEmail"){
		this.props.history.replace("/registerEmail");
	}else if(this.props.webPage === "/registerEmail"){
		this.props.history.replace("/registerName");
	}else{
		this.props.history.goBack();
	}
    
  };

  render() {
    const { webPage } = this.props;
    return (
      <>
        <div className="nav-buttons">
          <Link 
            to={'#'}
            onClick={(event)=>{this.back(event)}} className="previous-steps">
            <i className="fas fa-arrow-left"></i>
            {this.props.t("regCardScr-preStep")}
          </Link>
          <Link to="/" className="close-btn"></Link>
        </div>
        <nav className="form-nav">
          <ul className="pagination">
            <li
              className={`page-item  ${
                webPage === "/registerName" ? "active" : "previous"
              } name`}
            >
              <Link className="page-link" to={'#'}>
                <span className="icon">
                  <i className="far fa-user"></i>
                </span>
                <label>{this.props.t("regCardScr-name")}</label>
              </Link>
            </li>
            <li
              className={`page-item   ${
                webPage === "/registerName"
                  ? "next"
                  : webPage === "/registerEmail" || webPage === "/confirmEmail"
                  ? "active"
                  : "previous"
              }  email`}
            >
              <Link className="page-link" to={'#'}>
                <span className="icon">
                  <i className="far fa-envelope-open"></i>
                </span>
                <label>{this.props.t("regCardScr-email")}</label>
              </Link>
            </li>
            <li
              className={`page-item  ${
                webPage === "/registerName" ||
                webPage === "/registerEmail" ||
                webPage === "/confirmEmail"
                  ? "next"
                  : webPage === "/registerPhone" || webPage === "/confirmPhone"
                  ? "active"
                  : "previous"
              }  phone`}
            >
              <Link className="page-link" to={'#'}>
                <span className="icon">
                  <i className="fas fa-phone-alt"></i>
                </span>
                <label>{this.props.t("regCardScr-phone")}</label>
              </Link>
            </li>
            <li
              className={`page-item ${ 
                webPage === "/registerName" ||
                webPage === "/registerEmail" ||
                webPage === "/confirmEmail" ||
                webPage === "/registerPhone" ||
                webPage === "/confirmPhone"
                  ? "next"
                  : webPage === "/registerPassword"
                  ? "active"
                  : "previous"
              }  password`}
            >
              <Link className="page-link" to={'#'}>
                <span className="icon">
                  <i className="fas fa-lock"></i>
                </span>
                <label>{this.props.t("regCardScr-password")}</label>
              </Link>
            </li>
          </ul>
        </nav>
      </>
    );
  }
}

export default withTranslation()(withRouter(RegisterWizard));
